import React, { useEffect, useMemo, useState } from "react";
import useSearchData from "../../../components/useSearchData";
import { AddNursingAssessment } from "./AddNursingAssessment";
import SearchBox from "../../../components/Search/SearchBox";
import Icon from "../../../components/Icons/Icon";
import { createColumnDef, useOnGridReady } from "../../../Utils/AgGridUtils";
import { leftStyles } from "../../../Constants/Constants";
import FormikController from "../../../components/FormikController/FormikController";
import ClientStore from "../../../Store/ClientStore";
import AgencyStore from "../../../Store/AgencyStore";
import { useParams } from "react-router-dom";

const NursingAssessmentViewPage = () => {
  const [onGridReady] = useOnGridReady(ClientStore, "safetyAgGrid");
  const { clientId } = useParams();
  const [editData, setEditData] = useState([]);
  const [openEditButton, setOpenEditButton] = useState("save");
  const [nursingAssessList, setNursingAssessList] = useState(
    ClientStore?.nursingAssessmentList
  );
  const [show, setShow] = useState(false);
  const [handleSearchChange] = useSearchData();
  const handleOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setOpenEditButton("save");
  };

  const columnDefs = useMemo(
    () => [
      createColumnDef("clientName", "Client Name", leftStyles, "", "", 90),
      createColumnDef("rnName", "Nurse Name", leftStyles, "", "", 90),
      createColumnDef("doctorName", "Doctor Name", leftStyles, "", "", 90),

      createColumnDef(
        "contactPhoneNo",
        "Contact Phone No",
        leftStyles,
        "",
        "",
        90
      ),

      createColumnDef("visitType", "Visit Type", leftStyles, "", "", 70),
      createColumnDef("uploadDate", "Upload Date", leftStyles, "", "", 80),
      createColumnDef(
        "lastUpdatedDate",
        "Modified Date",
        leftStyles,
        "",
        "",
        80
      ),

      // {
      //   headerName: "Action",
      //   sortable: false,
      //   headerClass: "center-header",
      //   cellStyle: (params) => {
      //     return centerStyles;
      //   },
      //   width: 100,
      //   cellRenderer: (params) => {
      //     const handleEditButton = () => {
      //       setEditData(params.data);
      //       setOpenEditButton("update");
      //       handleOpen();
      //     };
      //     const handleDownloadButton = () => {
      //       // setEditData(params.data);
      //       // openPdf(<CGPOSPdf dataList={params.data} />);
      //     };
      //     return (
      //       <div
      //         style={{
      //           display: "flex",
      //           alignItems: "center",
      //           justifyContent: "center",
      //           gap: "10px",
      //         }}
      //       >
      //         <div className="manageClick" onClick={() => handleEditButton()}>
      //           Edit
      //         </div>
      //         {/* <div
      //           className="docViewText"
      //           onClick={() => handleDownloadButton()}
      //         >
      //           View
      //         </div> */}
      //       </div>
      //     );
      //   },
      // },
    ],
    []
  );

  useEffect(() => {
    if (AgencyStore.isSaveLoading) {
      const fetchData = async () => {
        await ClientStore.getNursingAssessment(clientId);
        setNursingAssessList(ClientStore?.nursingAssessmentList);
        AgencyStore.setIsSaveLoading(false);
      };
      fetchData();
    }
  }, [AgencyStore.isSaveLoading]);
  return (
    <div className="homeSafetyWrapper">
      {show ? (
        <>
          <AddNursingAssessment
            type={openEditButton}
            editData={editData}
            handleClose={handleClose}
            handleOpen={handleOpen}
          />
        </>
      ) : (
        <>
          <div className="actionButtonSearchMainContainer">
            <div className="searchMainCotainer">
              <div className="searchContainer">
                <SearchBox
                  handleChange={(e) => {
                    handleSearchChange(e, "DocList");
                  }}
                />
              </div>
              <div className="underlineClick" onClick={handleOpen}>
                <Icon iconName="circleAdd" />
                Add Nursing Assessments
              </div>
            </div>
          </div>
          <FormikController
            rowData={nursingAssessList}
            control="agGrid"
            columnDefs={columnDefs}
            onGridReady={onGridReady}
          />
        </>
      )}
    </div>
  );
};

export default NursingAssessmentViewPage;
